//公共serverice api 

exports.install = function (Vue, options) {
    Vue.prototype.getsource=function(sourceid){
        var resource = this.$resource(this.GLOBAL.BASE_URL + "api/getsource?id="+sourceid)
        return resource;
    };
    
}


// WEBPACK FOOTER //
// ./src/js/mainservice.js